<template>
  <div class="login">
    <div class="logon-img">
      <img src="@/assets/senkoo.png" alt="uniqo|wlt" class="logo" />
    </div>
    <div class="login-pancel">
      <img src="@/assets/login-back.png" alt="释空店铺助手" class="login-logo" />
      <div class="login-form">
        <div>
          <span class="login-title">{{$t('label.loginWelcome')}}</span>
        </div>
        <a-form-model :model="ruleForm" :rules="rules" ref="ruleForm" class="form-pancel">
          <a-form-model-item label prop="login_name" class="form-item">
            <a-input
              class="login-input"
              v-model="ruleForm.login_name"
              :placeholder="$t('label.account')"
              allow-clear
              size="large"
            >
              <img src="@/assets/login-user.png" slot="prefix" style="width:18px;height:18px;" />
            </a-input>
          </a-form-model-item>
          <a-form-model-item label prop="password"  class="form-item">
            <a-input
              class="login-input"
              v-model="ruleForm.password"
              type="password"
              :placeholder="$t('label.pass')"
              allow-clear
              size="large"
              @keyup.enter.native="login"
            >
              <img src="@/assets/login-pass.png" slot="prefix" style="width:18px;height:18px;" />
            </a-input>
          </a-form-model-item>
          <a-form-model-item>
            <div class="login-btn">
              <a-button
                class="btn-confirm"
                :class="{filled:formFilled}"
                @click="login('ruleForm')"
                type="success"
              >{{$t('label.login')}}</a-button>
            </div>
          </a-form-model-item>
          <a-form-model-item>
            {{$t('label.forgetPass')}}
            <a class="sk-link" href="tel:+86400-052-1616">{{$t('label.contactService')}}</a>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
    <div class="footer">
      <span>Copyright &copy; 2018-{{new Date().getFullYear()}} {{$t('label.copyright')}}</span>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      ruleForm: { login_name: "", password: "" },
      rules: {
        login_name: [
          { required: true, message:this.$t('label.inputAccount'), trigger: "blur" },
          { min: 1, max: 20, message: this.$t('label.inputLenAccount'), trigger: "blur" }
        ],
        password: [
          { required: true, message: this.$t('label.inputPass'), trigger: "blur" },
          { min: 3, max: 20, message: this.$t('label.inputLenPass'), trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    formFilled() {
      return this.ruleForm.login_name && this.ruleForm.password;
    }
  },
  methods: {
    ...mapActions(["setUser"]),
    login(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const loginform = {
            ...this.ruleForm,
            phone: this.ruleForm.login_name
          };
          this.$store.dispatch("login", loginform).then(res => {
            if (res.code === 200) {
              this.$router.push({ name: "home" });
            } else {
              this.$message.error(res.msg);
              return false;
            }
          });
        } else {
          console.log("error submit");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.login {
  height: 99vh;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  flex-direction: column;
  .login-title {
    font-size: 30px;
    color: #000;
  }
  .logon-img {
    display: flex;
    flex-direction: row;
    justify-content: start;
    padding: 80px;
    .logo {
      width: 84px;
      height: 40px;
    }
  }
  .login-pancel {
    flex: 2;
    width: 100%;
    display: flex;
    padding: 20px 80px;
    flex-direction: row;
    // justify-content: space-between;

    .login-logo {
      width: 45%;
      object-fit: contain;
      height: auto;
      margin-right: 20px;
    }
    .login-form {
      margin-left: 20px;
      width: 45%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .form-pancel {
        display: flex;
        // min-width: 450px;
        flex-direction: column;
        margin-top: 20px;
        .form-item{
          margin-top: 20px;
        } 
        /deep/ .ant-input-affix-wrapper .ant-input:not(:first-child) {
          padding-left: 42px;
        }
        .login-btn {
          margin-top: 30px;
          .btn-confirm {
            width: 260px;
            height: 46px;
            border-radius: 0;
            color: #fff;
            background: #000;
            font-weight: 500;
            font-size: 20px;
            // border: 1px solid rgba(52, 139, 218, 0.5);
            border: none;
          }
          .btn-confirm.filled {
            background: #000;
            // border: 1px solid rgba(52, 139, 218, 1);
          }
        }
      }
    }
  }
  .footer {
    height: 68px;
    line-height: 68px;
  }
}
@media screen and (max-width: 750px) {
  .login-pancel {
    width: 100%;
  }
}
</style>
